import objectFitImages from 'object-fit-images';

export const onInitialClientRender = () => {
  objectFitImages();
};
